<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 vs-con-loading__container" id="loginSubmitButton">
                <div class="vx-card__title mb-8">
                  <div class="flex">
                    <h4 class="mb-4 w-full">{{ $t('Login.FormTitle2') }}</h4>
                    <template>
                      <!-- I18N -->
                      <vs-dropdown
                        vs-custom-content
                        vs-trigger-click
                        class="cursor-pointer float-right mb-4"
                        :class="{'ml-5': breakpoint == 'md'}"
                      >
                        <span class="cursor-pointer flex i18n-locale">
                          <img
                            class="h-4 w-5"
                            :src="require(`@/assets/images/flags/${$i18n.locale}.png`)"
                            :alt="$i18n.locale"
                          />
                          <span class="sm:block ml-2 mr-2">{{ getCurrentLocaleData.lang }}</span>
                        </span>
                        <vs-dropdown-menu class="w-40 i18n-dropdown vx-navbar-dropdown">
                          <vs-dropdown-item @click="updateLocale('tr')">
                            <img class="h-4 w-5 mr-1" src="@/assets/images/flags/tr.png" alt="tr" /> &nbsp;Türkçe
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </template>
                  </div>
                  <p>{{ $t('Login.FormDesc2') }}</p>
                </div>

                <ValidationObserver
                  tag="form"
                  ref="loginform"
                  v-on:submit.prevent
                  v-slot="{ invalid }"
                >
                  <ValidationProvider
                    :name="$t('Login.Username')"
                    rules="required|min:3"
                    v-slot="{ errors }"
                  >
                    <vs-input
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label-placeholder="$t('Login.Username')"
                      v-model="formDataLogin.Username"
                      v-on:keyup.enter="login"
                      class="w-full no-icon-border"
                    />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>

                  <ValidationProvider
                    :name="$t('Login.Password')"
                    rules="required|min:3"
                    v-slot="{ errors }"
                  >
                    <vs-input
                      type="password"
                      name="password"
                      icon="icon icon-lock"
                      v-on:keyup.enter="login"
                      icon-pack="feather"
                      :label-placeholder="$t('Login.Password')"
                      v-model="formDataLogin.Password"
                      ref="inputPassword"
                      class="w-full mt-6 no-icon-border"
                    />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <vs-button
                    class="float-right my-5 vs-con-loading__container"
                    :disabled="invalid"
                    @click="login()"
                  >{{$t('Login.LoginButton')}}</vs-button>
                  <!-- <vs-divider>{{ $t('Login.OR') }}</vs-divider>

                  <div class="social-login flex flex-wrap justify-between">
                    <div class="social-login-buttons flex flex-wrap items-center mt-4">
                      <div
                        class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                        @click="loginWithGoogle"
                      >
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fab"
                          data-icon="google"
                          class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 488 512"
                        >
                          <path
                            fill="currentColor"
                            d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>-->
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import AuthApi from "@/api/auth";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: ""
      },
      submitBusy: false
    };
  },
  computed: {
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    }
  },
  methods: {
    handleLoginEvent(payload) {
      if (payload.loggedIn) {
        this.$router.push("/");
      } else {
        this.$router.push("/login");
      }
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    loginWithGoogle() {
      this.$store.dispatch("auth/loginWithGoogle", this);
    },
    async login() {
      const isValid = await this.$refs.loginform.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45
      });
      try {
        this.$recaptcha("login").then(async token => {
          this.formDataLogin.GoogleReCaptchaResponse = token;

          await this.$auth.login(this.formDataLogin, this);
        });
      } finally {
        this.submitBusy = false;
      }
    }
  }
};
</script>


<style lang="scss">
#page-login {
  .social-login {
    .bg-google {
      background-color: #4285f4;
    }
  }
}
</style>
